// ─── Intent Detection ────────────────────────────────────────────────────────
const ACTION_KEYWORDS = [
  'add', 'create', 'make', 'new', 'insert',
  'delete', 'remove', 'erase', 'trash', 'discard',
  'rename', 'retitle',
  'move', 'relocate', 'transfer',
  'edit', 'update', 'modify', 'change', 'replace',
  'set', 'apply', 'switch', 'toggle', 'turn', 'enable', 'disable',
  'organize', 'sort', 'clean', 'cleanup', 'reorder',
  'undo', 'revert', 'reset',

  'bm', 'bmk', 'bookmark', 'book mark',
  'save', 'save bookmark', 'save this', 'save site', 'save link',
  'add bookmark', 'create bookmark', 'make bookmark',
  'bookmark this', 'bookmark site', 'bookmark link',
  'clip', 'clip link', 'store', 'store link', 'keep link',

  'delete bookmark', 'remove bookmark', 'rename bookmark',
  'move bookmark', 'edit bookmark', 'update bookmark',
  'change bookmark', 'bookmark note', 'bookmark credentials',

  'folder', 'folders',
  'add folder', 'create folder', 'make folder', 'new folder',
  'delete folder', 'remove folder', 'rename folder',
  'move folder', 'edit folder', 'update folder',
  'nest folder', 'put folder in', 'move into folder',

  'share', 'shared', 'unshare',
  'invite', 'add member', 'add user',
  'remove member', 'revoke', 'revoke access',
  'change permission', 'update permission',
  'viewer', 'editor', 'owner',
  'leave shared folder',

  'open', 'launch', 'go', 'go to', 'visit', 'navigate', 'navigate to',
  'take me', 'take me to', 'bring up', 'load',
  'open site', 'open website', 'open link', 'open bookmark',
  'visit site', 'visit website',

  'add note', 'update note', 'edit note', 'change note',
  'add credentials', 'update credentials', 'edit credentials',
  'password', 'username', 'email', 'login', 'token', 'secret', 'credential', 'credentials',

  'audit', 'audit account', 'health check', 'health', 'duplicates',
  'stats', 'telemetry', 'overview',
  'organize', 'auto organize', 'clean root', 'organize root',
  'export', 'backup', 'export vault', 'density', 'preset',
  'duplicate', 'duplicates', 'dedupe', 'clean duplicates', 'find duplicates',
  'empty folder', 'empty folders', 'clean empty folders', 'purge empty folders',
  'batch tag', 'tag all', 'filter', 'filter view', 'clear filter',
  'help', 'capabilities', 'commands',
  'heal', 'heal links', 'broken links', 'dead links', 'link health', 'wayback',
  'harmonize', 'harmonize tags', 'synonym tags', 'merge tags',
  'cluster', 'cluster domains', 'domain folders',
  'suspend', 'sleep tabs', 'discard tabs', 'memory',
  'scrape', 'scrape links', 'harvest links',
  'tracking', 'strip tracking', 'sanitize', 'privacy',
  'stale', 'archive stale', 'unvisited',
  'sort', 'sort mode', 'order by',
  'wayback restore', 'archive snapshot', 'search tabs', 'find tab',
  'clone folder', 'duplicate folder', 'summarize topics', 'topic breakdown',
  'dedupe tabs', 'close duplicate tabs', 'inspect page', 'page metadata',
  'merge folders', 'export folder', 'reading queue', 'reading list',
  'clean titles', 'strip suffixes',
  'semantic search', 'cosine search', 'color folders', 'theme folders', 'auto color',
  'reading times', 'tag durations', 'reading durations', 'mixed content', 'insecure content',
  'library diff', 'snapshot diff', 'compare snapshots', 'diff snapshots', 'save quote', 'quote bookmark',
  'untag', 'remove tag', 'lonely bookmarks', 'lonely', 'orphaned bookmarks',
  'unfurl shortlinks', 'expand shortlinks', 'shortlinks', 'tab matrix',
  'daily briefing', 'morning briefing', 'executive briefing', 'tag domains', 'domain tags',
  'dedupe notes', 'clean notes', 'duplicate notes', 'markdown table', 'export table',
  'stale credentials', 'weak passwords', 'close tab by pattern', 'kill tabs',
  'save article', 'extract article', 'flatten folders', 'flatten hierarchy',
  'bulk rename', 'batch rename', 'diagnostics', 'ai diagnostics',

  'theme', 'appearance', 'style', 'look',
  'background', 'background color', 'background type',
  'accent', 'accent color',
  'color', 'colors', 'colour', 'colours', 'clr',
  'palette', 'shade', 'tint',
  'dark', 'light', 'mode', 'dark mode', 'light mode',
  'font', 'font color', 'text color',
  'heading', 'heading color',
  'title text', 'title color',
  'body text', 'body color',
  'subtitle', 'subtitle color',
  'label', 'labels', 'label color',
  'muted', 'muted color',
  'chat', 'chat bubble', 'chat text',
  'message', 'bubble',
  'ai', 'ai bubble', 'ai text',
  'reply', 'response',
  'user bubble', 'user text',
  'button', 'button color',
  'icon', 'icon color',
  'page', 'page color',
  'panel', 'panel color',
  'card', 'card color',
  'tile', 'tile color',
  'folder color', 'folder area',
  'border', 'border color',
  'surface', 'surface color',

  'animation', 'animated background', 'gradient', 'wallpaper',
  'custom background', 'background image',
  'turn off background', 'turn on background',

  'shrae', 'shrare', 'edtor', 'editr',
  'colro', 'colur', 'chnage', 'updat', 'renmae', 'delte', 'mvoe',
  'bokmark', 'boomark', 'bookmrk', 'bookmak',
];

const RETRIEVAL_KEYWORDS = [
  'list', 'show', 'what', 'which', 'find', 'search', 'lookup',
  'how many', 'where', 'get', 'all', 'any',
  'tell me', 'do i have', 'check', 'read',
  'inside', 'contain', 'contains', 'under', 'in',
  'count', 'total',

  'bookmarks', 'folders', 'items', 'sites', 'websites', 'links',
  'bookmark', 'folder', 'item', 'site', 'website', 'link',

  'note', 'notes',
  'credential', 'credentials', 'password', 'username', 'email', 'login', 'key', 'secret', 'token',
  'give me', 'read note', 'read credentials',
];

const APPEARANCE_HINTS = [
  'change color',
  'change colours',
  'change colour',
  'set color',
  'set colour',
  'under folder',
  'folder area',
  'tile color',
  'card color',
  'panel color',
  'chat bubble',
  'chat text',
  'ai bubble',
  'ai text',
  'heading color',
  'body text color',
  'subtitle color',
  'label color',
  'background color',
  'page color',
  'border color',
  'surface color',
  'accent color',
];

export const VALID_ACTIONS = new Set([
  'open_bookmark',
  'add_bookmark',
  'add_folder',
  'delete_bookmark',
  'delete_folder',
  'rename_bookmark',
  'rename_folder',
  'move_bookmark',
  'move_folder',
  'update_note',
  'update_credentials',
  'update_url',
  'update_bookmark',
  'get_credentials',
  'get_note',
  'bulk_delete',
  'share_folder',
  'revoke_shared_member',
  'update_permission',
  'leave_shared_folder',
  'apply_background',
  'apply_mode',
  'apply_font_colors',
  'reset_font_colors',
  'list_bookmarks',
  'audit_account',
  'auto_organize_root',
  'open_folder_tabs',
  'audit_vault_security',
  'export_vault',
  'get_account_stats',
  'apply_theme_preset',
  'set_view_density',
  'save_all_tabs',
  'extract_page_links',
  'search_library',
  'clean_duplicates',
  'find_duplicates',
  'clean_empty_folders',
  'purge_empty_folders',
  'batch_tag',
  'filter_view',
  'reset_filter',
  'get_ai_capabilities',
  'heal_broken_links',
  'check_link_health',
  'harmonize_tags',
  'merge_tags',
  'cluster_by_domain',
  'sleep_inactive_tabs',
  'scrape_page_links',
  'sanitize_tracking_params',
  'archive_stale_bookmarks',
  'set_sort_mode',
  'wayback_restore',
  'archive_snapshot',
  'search_open_tabs',
  'clone_folder',
  'duplicate_folder',
  'summarize_vault_topics',
  'clean_duplicate_tabs',
  'inspect_active_page',
  'extract_page_metadata',
  'merge_folders',
  'export_selected_folder',
  'ai_reading_queue',
  'clean_title_suffixes',
  'semantic_search_library',
  'auto_color_folders',
  'tag_reading_durations',
  'audit_mixed_content',
  'compare_library_snapshots',
  'save_quote_to_bookmark',
  'bulk_untag',
  'find_lonely_bookmarks',
  'unfurl_shortlinks',
  'get_tab_matrix',
  'generate_daily_briefing',
  'batch_tag_by_domain',
  'dedupe_notes',
  'export_markdown_table',
  'audit_stale_credentials',
  'close_tab_by_pattern',
  'save_page_article',
  'flatten_deep_folders',
  'bulk_rename_bookmarks',
  'ai_diagnostics',
]);

function normalizeText(s = '') {
  return s
    .toLowerCase()
    .trim()
    .replace(/([a-z])\1{2,}/g, '$1')
    .replace(/[^\w\s#@.:/-]/g, ' ')
    .replace(/\s+/g, ' ');
}

function withinOneEdit(a, b) {
  if (!a || !b) return false;
  if (Math.abs(a.length - b.length) > 1) return false;
  if (a === b) return true;

  let i = 0;
  let j = 0;
  let edits = 0;

  while (i < a.length && j < b.length) {
    if (a[i] === b[j]) {
      i++;
      j++;
    } else {
      edits++;
      if (edits > 1) return false;
      if (a.length > b.length) i++;
      else if (b.length > a.length) j++;
      else {
        i++;
        j++;
      }
    }
  }

  if (i < a.length || j < b.length) edits++;
  return edits <= 1;
}

function hasFuzzyKeyword(lower, keywordList) {
  const tokens = lower.split(' ');

  for (const kw of keywordList) {
    if (kw.includes(' ')) {
      if (lower.includes(kw)) return true;
      continue;
    }

    if (tokens.includes(kw)) return true;
    if (tokens.some((t) => t.length >= 4 && withinOneEdit(t, kw))) return true;
  }

  return false;
}

function isBookmarkShortcutIntent(lower) {
  return /^(bm|bmk|bookmark|save)\b/.test(lower);
}

export function isActionIntent(text) {
  const lower = normalizeText(text || '');
  if (!lower) return false;

  if (isBookmarkShortcutIntent(lower)) return true;
  if (/turnon|turnoff/.test(lower)) return true;
  if (/#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})\b/i.test(lower)) return true;
  if (APPEARANCE_HINTS.some((p) => lower.includes(p))) return true;

  const hasAction = hasFuzzyKeyword(lower, ACTION_KEYWORDS);
  if (hasAction) return true;

  return hasFuzzyKeyword(lower, RETRIEVAL_KEYWORDS);
}

export function stripThinking(text = '') {
  if (!text || typeof text !== 'string') return '';
  return text
    .replace(/<think>[\s\S]*?<\/think>/gi, '')
    .replace(/<reasoning>[\s\S]*?<\/reasoning>/gi, '')
    .trim();
}

export function stripSpecialTokens(text = '') {
  if (!text || typeof text !== 'string') return '';
  return text
    .replace(/<think>[\s\S]*?<\/think>/gi, '')
    .replace(/<reasoning>[\s\S]*?<\/reasoning>/gi, '')
    .replace(/<\|tool_call_start\|>[\s\S]*?<\|tool_call_end\|>/gi, '')
    .replace(/<\|tool_call_start\|>[\s\S]*$/gi, '')
    .replace(/<\|tool_call_end\|>/gi, '')
    .replace(/<tool_call(?:s)?>[\s\S]*?<\/tool_call(?:s)?>/gi, '')
    .replace(/<tool_call(?:s)?>[\s\S]*$/gi, '')
    .replace(/<\/tool_call(?:s)?>/gi, '')
    .replace(/<\|im_start\|>[\s\S]*?<\|im_end\|>/gi, '')
    .replace(/<\|[^|>]+\|>/gi, '')
    .trim();
}

// ─── JSON & Function Call Parsers ─────────────────────────────────────────────

export function extractJSON(text) {
  if (!text || typeof text !== 'string') return null;
  const clean = stripThinking(text).trim();

  try {
    if (clean.startsWith('{') || clean.startsWith('[')) {
      return JSON.parse(clean);
    }
  } catch (_) {}

  return null;
}

function coerceParsedToActionList(parsed) {
  if (!parsed) return [];
  if (Array.isArray(parsed)) return parsed;
  if (parsed && Array.isArray(parsed.actions)) return parsed.actions;
  if (parsed && Array.isArray(parsed.tool_calls)) return parsed.tool_calls;
  if (parsed && typeof parsed === 'object') return [parsed];
  return [];
}

export const ACTION_ALIASES = {
  open_url: 'open_bookmark',
  open_link: 'open_bookmark',
  open: 'open_bookmark',
  launch: 'open_bookmark',
  save_bookmark: 'add_bookmark',
  create_bookmark: 'add_bookmark',
  new_bookmark: 'add_bookmark',
  save: 'add_bookmark',
  create_folder: 'add_folder',
  new_folder: 'add_folder',
  make_folder: 'add_folder',
  remove_bookmark: 'delete_bookmark',
  remove_folder: 'delete_folder',
  trash_bookmark: 'delete_bookmark',
  trash_folder: 'delete_folder',
  change_theme: 'apply_theme',
  set_theme: 'apply_theme',
  set_background: 'apply_background',
  change_background: 'apply_background',
  set_colors: 'apply_font_colors',
  change_colors: 'apply_font_colors',
  search_bookmarks: 'list_bookmarks',
  find_bookmarks: 'list_bookmarks',
  show_bookmarks: 'list_bookmarks',
  record_note: 'update_note',
  audit: 'audit_account',
  account_audit: 'audit_account',
  audit_library: 'audit_account',
  stats: 'get_account_stats',
  account_stats: 'get_account_stats',
  telemetry: 'get_account_stats',
  organize_root: 'auto_organize_root',
  clean_root: 'auto_organize_root',
  auto_organize: 'auto_organize_root',
  open_all: 'open_folder_tabs',
  open_folder: 'open_folder_tabs',
  open_all_tabs: 'open_folder_tabs',
  vault_audit: 'audit_vault_security',
  security_audit: 'audit_vault_security',
  check_passwords: 'audit_vault_security',
  export: 'export_vault',
  backup: 'export_vault',
  theme_preset: 'apply_theme_preset',
  view_density: 'set_view_density',
  search: 'search_library',
  remove_duplicates: 'clean_duplicates',
  dedupe: 'clean_duplicates',
  dedupe_library: 'clean_duplicates',
  check_duplicates: 'find_duplicates',
  show_duplicates: 'find_duplicates',
  empty_folders: 'clean_empty_folders',
  remove_empty_folders: 'clean_empty_folders',
  purge_empty_folders: 'clean_empty_folders',
  tag_all: 'batch_tag',
  bulk_tag: 'batch_tag',
  filter: 'filter_view',
  show_only: 'filter_view',
  clear_filter: 'reset_filter',
  clear_filters: 'reset_filter',
  help: 'get_ai_capabilities',
  capabilities: 'get_ai_capabilities',
  ai_help: 'get_ai_capabilities',
  heal_links: 'heal_broken_links',
  check_links: 'check_link_health',
  link_health: 'check_link_health',
  clean_tags: 'harmonize_tags',
  tag_cleanup: 'harmonize_tags',
  cluster_domains: 'cluster_by_domain',
  sort_domains: 'cluster_by_domain',
  group_by_domain: 'cluster_by_domain',
  suspend_tabs: 'sleep_inactive_tabs',
  discard_tabs: 'sleep_inactive_tabs',
  sleep_tabs: 'sleep_inactive_tabs',
  scrape_links: 'scrape_page_links',
  harvest_links: 'scrape_page_links',
  strip_tracking: 'sanitize_tracking_params',
  clean_tracking: 'sanitize_tracking_params',
  archive_stale: 'archive_stale_bookmarks',
  sort_by: 'set_sort_mode',
  sort_mode: 'set_sort_mode',
  wayback: 'wayback_restore',
  archive_url: 'wayback_restore',
  find_tabs: 'search_open_tabs',
  find_tab: 'search_open_tabs',
  search_tabs: 'search_open_tabs',
  copy_folder: 'clone_folder',
  vault_topics: 'summarize_vault_topics',
  topic_breakdown: 'summarize_vault_topics',
  library_breakdown: 'summarize_vault_topics',
  dedupe_tabs: 'clean_duplicate_tabs',
  close_duplicate_tabs: 'clean_duplicate_tabs',
  page_info: 'inspect_active_page',
  page_metadata: 'inspect_active_page',
  combine_folders: 'merge_folders',
  export_folder: 'export_selected_folder',
  reading_queue: 'ai_reading_queue',
  reading_list: 'ai_reading_queue',
  clean_titles: 'clean_title_suffixes',
  strip_suffixes: 'clean_title_suffixes',
  semantic_search: 'semantic_search_library',
  ai_search: 'semantic_search_library',
  color_folders: 'auto_color_folders',
  color_folder: 'auto_color_folders',
  theme_folders: 'auto_color_folders',
  reading_times: 'tag_reading_durations',
  tag_durations: 'tag_reading_durations',
  mixed_content: 'audit_mixed_content',
  check_mixed_content: 'audit_mixed_content',
  insecure_links: 'audit_mixed_content',
  library_diff: 'compare_library_snapshots',
  snapshot_diff: 'compare_library_snapshots',
  save_quote: 'save_quote_to_bookmark',
  untag: 'bulk_untag',
  remove_tag: 'bulk_untag',
  lonely_bookmarks: 'find_lonely_bookmarks',
  orphan_bookmarks: 'find_lonely_bookmarks',
  orphaned_bookmarks: 'find_lonely_bookmarks',
  expand_shortlinks: 'unfurl_shortlinks',
  tab_matrix: 'get_tab_matrix',
  daily_briefing: 'generate_daily_briefing',
  briefing: 'generate_daily_briefing',
  morning_briefing: 'generate_daily_briefing',
  tag_domains: 'batch_tag_by_domain',
  auto_tag_domains: 'batch_tag_by_domain',
  domain_tags: 'batch_tag_by_domain',
  duplicate_notes: 'dedupe_notes',
  clean_notes: 'dedupe_notes',
  dedupe_notes: 'dedupe_notes',
  markdown_table: 'export_markdown_table',
  export_table: 'export_markdown_table',
  table_export: 'export_markdown_table',
  stale_credentials: 'audit_stale_credentials',
  weak_passwords: 'audit_stale_credentials',
  stale_passwords: 'audit_stale_credentials',
  close_tabs: 'close_tab_by_pattern',
  kill_tabs: 'close_tab_by_pattern',
  save_article: 'save_page_article',
  extract_article: 'save_page_article',
  flatten_folders: 'flatten_deep_folders',
  flatten_hierarchy: 'flatten_deep_folders',
  bulk_rename: 'bulk_rename_bookmarks',
  batch_rename: 'bulk_rename_bookmarks',
  diagnostics: 'ai_diagnostics',
  ai_status: 'ai_diagnostics',
  system_status: 'ai_diagnostics',
};

function normalizeParsedItem(item) {
  if (!item || typeof item !== 'object') return null;

  let actionName = (item.action || item.name || item.tool || '').trim();
  let args = {};

  if (item.function && typeof item.function === 'object') {
    actionName = actionName || (item.function.name || '').trim();
    const fnArgs = item.function.arguments || item.function.parameters;
    if (typeof fnArgs === 'string') {
      try { args = JSON.parse(fnArgs); } catch (_) {}
    } else if (fnArgs && typeof fnArgs === 'object') {
      args = fnArgs;
    }
  }

  if (item.arguments) {
    if (typeof item.arguments === 'string') {
      try { args = { ...args, ...JSON.parse(item.arguments) }; } catch (_) {}
    } else if (typeof item.arguments === 'object') {
      args = { ...args, ...item.arguments };
    }
  }

  if (item.parameters) {
    if (typeof item.parameters === 'string') {
      try { args = { ...args, ...JSON.parse(item.parameters) }; } catch (_) {}
    } else if (typeof item.parameters === 'object') {
      args = { ...args, ...item.parameters };
    }
  }

  const merged = { ...item, ...args };
  if (actionName) merged.action = actionName;

  if (merged.action) {
    const lowerAct = merged.action.toLowerCase();
    merged.action = ACTION_ALIASES[lowerAct] || lowerAct;
  }

  if (merged.folder && !merged.folderTitle) merged.folderTitle = merged.folder;
  if (merged.folder_title && !merged.folderTitle) merged.folderTitle = merged.folder_title;
  if (merged.parent && !merged.parentFolder) merged.parentFolder = merged.parent;
  if (merged.parent_folder && !merged.parentFolder) merged.parentFolder = merged.parent_folder;
  if (merged.parent_id && !merged.parentId) merged.parentId = merged.parent_id;

  return merged;
}

function normalizeParsedToActions(parsed) {
  const list = coerceParsedToActionList(parsed);

  return list
    .map(normalizeParsedItem)
    .filter(
      (p) =>
        p &&
        typeof p === 'object' &&
        p.action &&
        p.action !== 'none' &&
        VALID_ACTIONS.has(p.action)
    );
}

export function parseFunctionCalls(text = '') {
  if (!text || typeof text !== 'string') return [];
  const actions = [];

  // Match function calls like [open_bookmark(title='Jitsi')] or open_bookmark(title="Jitsi", url="...")
  const callRegex = /(?:\[|\b)([a-zA-Z0-9_]+)\s*\(([\s\S]*?)\)\]?/g;
  let match;

  while ((match = callRegex.exec(text)) !== null) {
    const rawName = (match[1] || '').trim();
    const rawArgs = (match[2] || '').trim();

    let actionName = rawName.toLowerCase();
    const mapped = ACTION_ALIASES[actionName] || actionName;

    if (!VALID_ACTIONS.has(mapped)) continue;

    const actionObj = { action: mapped };

    if (!rawArgs) {
      actions.push(actionObj);
      continue;
    }

    const kwargRegex = /([a-zA-Z0-9_]+)\s*=\s*(?:'([^']*)'|"([^"]*)"|`([^`]*)`|([a-zA-Z0-9_#.:\/-]+|\[[^\]]*\]|\{[^}]*\}))/g;
    let kwMatch;
    let hasKwargs = false;

    while ((kwMatch = kwargRegex.exec(rawArgs)) !== null) {
      hasKwargs = true;
      const key = kwMatch[1];
      let val = kwMatch[2] !== undefined ? kwMatch[2] : (kwMatch[3] !== undefined ? kwMatch[3] : (kwMatch[4] !== undefined ? kwMatch[4] : kwMatch[5]));

      if (val === 'true') val = true;
      else if (val === 'false') val = false;
      else if (val === 'null' || val === 'None') val = null;
      else if (typeof val === 'string' && /^-?\d+(?:\.\d+)?$/.test(val)) val = Number(val);

      if (key === 'folder' || key === 'folder_title' || key === 'target_folder') {
        actionObj.folderTitle = val;
      } else if (key === 'parent' || key === 'parent_folder') {
        actionObj.parentFolder = val;
      } else if (key === 'parent_id') {
        actionObj.parentId = val;
      } else if (key === 'query') {
        actionObj.query = val;
        if (!actionObj.title) actionObj.title = val;
      } else if (key === 'name' && !actionObj.title) {
        actionObj.title = val;
      } else {
        actionObj[key] = val;
      }
    }

    // Positional string fallback e.g. open_bookmark('Jitsi') or open_bookmark('https://...')
    if (!hasKwargs) {
      const singleStrMatch = rawArgs.match(/^['"`]([^'"`]+)['"`]$/);
      if (singleStrMatch) {
        const val = singleStrMatch[1].trim();
        if (mapped === 'open_bookmark') {
          if (/^https?:\/\//i.test(val)) actionObj.url = val;
          else {
            actionObj.title = val;
            actionObj.query = val;
          }
        } else if (mapped === 'add_folder' || mapped === 'delete_folder' || mapped === 'delete_bookmark' || mapped === 'get_credentials' || mapped === 'get_note') {
          actionObj.title = val;
        } else if (mapped === 'apply_background') {
          actionObj.backgroundType = val;
        } else if (mapped === 'list_bookmarks') {
          actionObj.folderTitle = val;
        }
      }
    }

    actions.push(actionObj);
  }

  return actions;
}

export function extractUnknownActions(text) {
  if (!text || typeof text !== 'string') return [];
  const clean = stripThinking(text);

  const tryCandidates = [];

  const parsed = extractJSON(clean);
  if (parsed) tryCandidates.push(...coerceParsedToActionList(parsed));

  const looseArray = tryParseLooseJsonArrayRaw(clean);
  if (looseArray.length > 0) tryCandidates.push(...looseArray);

  const singleObj = tryParseSingleJsonObjectRaw(clean);
  if (singleObj.length > 0) tryCandidates.push(...singleObj);

  const unknown = [];
  const seen = new Set();
  for (const item of tryCandidates) {
    const normalized = normalizeParsedItem(item);
    if (
      normalized &&
      typeof normalized === 'object' &&
      normalized.action &&
      normalized.action !== 'none' &&
      !VALID_ACTIONS.has(normalized.action)
    ) {
      const key = `${normalized.action}::${JSON.stringify(normalized)}`;
      if (!seen.has(key)) {
        seen.add(key);
        unknown.push(normalized);
      }
    }
  }

  return unknown;
}

function tryParseLooseJsonArrayRaw(text) {
  if (!text || typeof text !== 'string') return [];

  let t = stripThinking(text)
    .replace(/[“”]/g, '"')
    .replace(/[‘’]/g, "'")
    .replace(/\u00A0/g, ' ')
    .trim();

  const start = t.indexOf('[');
  const end = t.lastIndexOf(']');
  if (start === -1 || end === -1 || end <= start) return [];

  let candidate = t.slice(start, end + 1);
  candidate = candidate.replace(/,\s*([}\]])/g, '$1');

  try {
    const parsed = JSON.parse(candidate);
    return coerceParsedToActionList(parsed);
  } catch (_) {
    return [];
  }
}

function tryParseSingleJsonObjectRaw(text) {
  if (!text || typeof text !== 'string') return [];

  let t = stripThinking(text)
    .replace(/[“”]/g, '"')
    .replace(/[‘’]/g, "'")
    .replace(/\u00A0/g, ' ')
    .trim();

  const start = t.indexOf('{');
  const end = t.lastIndexOf('}');
  if (start === -1 || end === -1 || end <= start) return [];

  let candidate = t.slice(start, end + 1);
  candidate = candidate.replace(/,\s*([}\]])/g, '$1');

  try {
    const parsed = JSON.parse(candidate);
    return coerceParsedToActionList(parsed);
  } catch (_) {
    return [];
  }
}

function tryParseLooseJsonArray(text) {
  return normalizeParsedToActions(tryParseLooseJsonArrayRaw(text));
}

function tryParseSingleJsonObject(text) {
  return normalizeParsedToActions(tryParseSingleJsonObjectRaw(text));
}

function tryParseAnyJson(str) {
  if (!str || typeof str !== 'string') return [];
  const trimmed = str.trim();
  try {
    const parsed = JSON.parse(trimmed);
    const normalized = normalizeParsedToActions(parsed);
    if (normalized.length > 0) return normalized;
  } catch (_) {}

  const strict = normalizeParsedToActions(extractJSON(trimmed));
  if (strict.length > 0) return strict;

  const looseArray = tryParseLooseJsonArray(trimmed);
  if (looseArray.length > 0) return looseArray;

  const singleObj = tryParseSingleJsonObject(trimmed);
  if (singleObj.length > 0) return singleObj;

  return [];
}

function dedupeActionList(actions = []) {
  const seen = new Set();
  const out = [];
  for (const a of actions) {
    const key = `${a.action}::${JSON.stringify(a)}`;
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(a);
  }
  return out;
}

export function parseActions(text) {
  if (!text || typeof text !== 'string') return [];
  const clean = stripThinking(text);
  const actions = [];

  // 1. Tagged blocks: <|tool_call_start|>...<|tool_call_end|> (Qwen/Hermes)
  const specialTagMatches = clean.matchAll(/<\|tool_call_start\|>([\s\S]*?)(?:<\|tool_call_end\|>|$)/gi);
  for (const match of specialTagMatches) {
    const block = (match[1] || '').trim();
    if (!block) continue;
    const jsonActions = tryParseAnyJson(block);
    if (jsonActions.length > 0) {
      actions.push(...jsonActions);
    } else {
      const fnActions = parseFunctionCalls(block);
      if (fnActions.length > 0) actions.push(...fnActions);
    }
  }

  // 2. XML-style <tool_call>...</tool_call>
  const toolCallXmlMatches = clean.matchAll(/<tool_call(?:s)?>([\s\S]*?)(?:<\/tool_call(?:s)?>|$)/gi);
  for (const match of toolCallXmlMatches) {
    const block = (match[1] || '').trim();
    if (!block) continue;
    const jsonActions = tryParseAnyJson(block);
    if (jsonActions.length > 0) {
      actions.push(...jsonActions);
    } else {
      const fnActions = parseFunctionCalls(block);
      if (fnActions.length > 0) actions.push(...fnActions);
    }
  }

  // 3. $TOOL_CALLS$ block format
  const toolCallsDelimiterMatches = clean.matchAll(/\$TOOL_CALLS\$([\s\S]*?)(?=(?:\$TOOL_CALLS\$|\n\n[A-Z]|$))/gi);
  for (const match of toolCallsDelimiterMatches) {
    const block = (match[1] || '').trim();
    if (!block) continue;
    const jsonActions = tryParseAnyJson(block);
    if (jsonActions.length > 0) {
      actions.push(...jsonActions);
    } else {
      const fnActions = parseFunctionCalls(block);
      if (fnActions.length > 0) actions.push(...fnActions);
    }
  }

  // 4. Fenced code blocks ```(?:json)? ... ```
  const fenceRegex = /```(?:json|JSON)?\s*([\s\S]*?)```/gi;
  let fenceMatch;
  while ((fenceMatch = fenceRegex.exec(clean)) !== null) {
    const block = (fenceMatch[1] || '').trim();
    if (!block) continue;
    const jsonActions = tryParseAnyJson(block);
    if (jsonActions.length > 0) {
      actions.push(...jsonActions);
    } else {
      const fnActions = parseFunctionCalls(block);
      if (fnActions.length > 0) actions.push(...fnActions);
    }
  }

  if (actions.length > 0) return dedupeActionList(actions);

  // 5. Direct full-text JSON parsing
  const fullJson = tryParseAnyJson(clean);
  if (fullJson.length > 0) return fullJson;

  // 6. Full-text Python / Hermes function call parsing
  const fullFnCalls = parseFunctionCalls(clean);
  if (fullFnCalls.length > 0) return dedupeActionList(fullFnCalls);

  return [];
}

export function cleanAssistantDisplayText(text = '') {
  if (!text || typeof text !== 'string') return '';
  let out = text;

  // Strip thinking blocks
  out = out.replace(/<think>[\s\S]*?<\/think>/gi, '');
  out = out.replace(/<reasoning>[\s\S]*?<\/reasoning>/gi, '');

  // Strip special token tool call wrappers
  out = out.replace(/<\|tool_call_start\|>[\s\S]*?<\|tool_call_end\|>/gi, '');
  out = out.replace(/<\|tool_call_start\|>[\s\S]*$/gi, '');
  out = out.replace(/<\|tool_call_end\|>/gi, '');

  // Strip xml-like tool call wrappers
  out = out.replace(/<tool_call(?:s)?>[\s\S]*?<\/tool_call(?:s)?>/gi, '');
  out = out.replace(/<tool_call(?:s)?>[\s\S]*$/gi, '');
  out = out.replace(/<\/tool_call(?:s)?>/gi, '');

  // Strip $TOOL_CALLS$ blocks
  out = out.replace(/\$TOOL_CALLS\$[\s\S]*$/gi, '');

  // Strip any leftover special tokens
  out = out.replace(/<\|im_start\|>[\s\S]*?<\|im_end\|>/gi, '');
  out = out.replace(/<\|[^|>]+\|>/gi, '');

  // Strip system prompt leakage
  out = out.replace(/Execute ONLY the latest user request[\s\S]*$/gi, '');
  out = out.replace(/Completed actions from older turns[\s\S]*$/gi, '');

  // Strip code fences containing tool call JSON
  out = out.replace(/```(?:json|JSON)?\s*\[\s*\{[\s\S]*?\}\s*\]\s*```/gi, '');
  out = out.replace(/```(?:json|JSON)?\s*\{[\s\S]*?\}\s*```/gi, '');
  out = out.replace(/```(?:json|JSON)?[\s\S]*?```/gi, '');

  // Strip standalone Python-style function calls like [open_bookmark(...)] or open_bookmark(...)
  out = out.replace(/(?:^|\n)\s*\[?\s*[a-zA-Z0-9_]+\s*\([\s\S]*?\)\s*\]?\s*(?:\n|$)/gi, '\n');

  // Strip bare JSON array/object action blocks
  out = out.replace(/(?:^|\n)\s*\[\s*\{\s*"action"\s*:[\s\S]*?\}\s*\]\s*(?:\n|$)/gi, '\n');
  out = out.replace(/(?:^|\n)\s*\{\s*"action"\s*:[\s\S]*?\}\s*(?:\n|$)/gi, '\n');

  return out.trim();
}

export function stripJsonBlocks(text) {
  return cleanAssistantDisplayText(text);
}